import { Button, Checkbox, Modal, Space, Typography, message } from 'antd'
import React from 'react'
import { ISellerNotice } from 'models/sellerNotices'

interface SellerNoticeModalProps {
  notice: Pick<
    ISellerNotice,
    'title' | 'text' | 'link_url' | 'link_text'
  > | null
  // hide — продавец отметил «Не показывать снова». Если onClose упадёт, модалка останется открытой
  onClose: (hide: boolean) => Promise<void> | void
}

export const SellerNoticeModal: React.FC<SellerNoticeModalProps> = ({
  notice,
  onClose
}) => {
  const [isHidden, setIsHidden] = React.useState(false)
  const [isSaving, setIsSaving] = React.useState(false)
  // Держим последнее уведомление, чтобы текст не пропадал, пока модалка закрывается
  const lastNoticeRef = React.useRef(notice)
  if (notice) lastNoticeRef.current = notice
  const shownNotice = lastNoticeRef.current

  React.useEffect(() => {
    setIsHidden(false)
  }, [notice])

  const handleAcknowledge = async () => {
    setIsSaving(true)
    try {
      await onClose(isHidden)
    } catch {
      message.error('Не удалось сохранить, попробуйте ещё раз')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <Modal
      open={Boolean(notice)}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      onOk={handleAcknowledge}
      confirmLoading={isSaving}
      okText='OK'
      footer={(_, { OkBtn }) => (
        <>
          {shownNotice?.link_url && (
            <Button
              href={shownNotice.link_url}
              target='_blank'
              rel='noopener noreferrer'
            >
              {shownNotice.link_text || 'Подробнее'}
            </Button>
          )}
          <OkBtn />
        </>
      )}
      title={shownNotice?.title}
    >
      <Space direction='vertical' size='middle'>
        <Typography.Text style={{ whiteSpace: 'pre-line' }}>
          {shownNotice?.text}
        </Typography.Text>
        <Checkbox
          checked={isHidden}
          onChange={(e) => setIsHidden(e.target.checked)}
        >
          Не показывать снова
        </Checkbox>
      </Space>
    </Modal>
  )
}
